export { default } from './FavouriteStar';
